export default __webpack_public_path__ + "static/media/arco-ajuda.5c4392d6.webp";